import { render, staticRenderFns } from "./VeJwJingsaiPersonalModal.vue?vue&type=template&id=ed7a3896"
import script from "./VeJwJingsaiPersonalModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiPersonalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports